module.exports = __webpack_public_path__ + "static/media/bm.88b5829a.svg";